export const CtpSpotlights = {
	Inactive: 'INACTIVE',
	Timeline: 'portfolio-3/ctp-onboarding/timeline',
	CreateIssue: 'portfolio-3/ctp-onboarding/create-issue',
	Teams: 'portfolio-3/ctp-onboarding/teams',
	Boards: 'portfolio-3/ctp-onboarding/boards',
} as const;
export type CtpSpotlights = (typeof CtpSpotlights)[keyof typeof CtpSpotlights];
